import React, {useMemo} from 'react';
import {startCase} from 'lodash';

import {Badge} from '@albert-io/atomic';
import type {BadgeStatuses as BadgeStatus} from '@albert-io/atomic/atoms/Badge/Badge.react';

type AssignmentStatus = 'inProgress' | 'notStarted' | 'pastDue' | 'submitted';

interface Props {
  isPastDue: boolean;
  status: Exclude<AssignmentStatus, 'pastDue'>;
}

const assignmentStatusToBadgeStatus = new Map<AssignmentStatus, BadgeStatus>([
  ['inProgress', 'info'],
  ['notStarted', 'neutral'],
  ['pastDue', 'negative'],
  ['submitted', 'positive']
]);

export default function AssignmentStatusBadge({isPastDue, status}: Props) {
  const assignmentStatus = useMemo(() => {
    let ret: AssignmentStatus = status;

    if (isPastDue && ['inProgress', 'notStarted'].includes(status)) {
      ret = 'pastDue';
    }

    return ret;
  }, [isPastDue, status]);

  return (
    <Badge
      emphasis='subtle'
      roundness='square'
      status={assignmentStatusToBadgeStatus.get(assignmentStatus)}
    >
      {startCase(assignmentStatus)}
    </Badge>
  );
}
